import { AppAbility, Action, Subject } from "./casl-ability.factory";

/**
 * Filters an object's fields to only those the ability permits for a given action and subject.
 * Fields where ability.can(action, subject, field) returns false are omitted from the result.
 */
export function filterByAbility<T extends Record<string, unknown>>(
  ability: AppAbility,
  action: Action,
  subject: Subject,
  data: T,
): Partial<T> {
  return Object.fromEntries(
    Object.entries(data).filter(([field]) => ability.can(action, subject, field)),
  ) as Partial<T>;
}
